import {
  UserImpactAggregates,
  User,
  PublicProjectSummary,
  GetImpactReportCsvRequestBody,
  ImpactType,
  values,
} from "@ecologi/shared";
import { CompleteProfileBanner } from "../CompleteProfileBanner";
import React, { useState } from "react";
import { ProfileHeader } from "../ProfileHeader";
import { Wrapper } from "../Wrapper";
import { ImpactStats, CombinedImpactQuantities } from "../ImpactStats";
import styled from "@emotion/styled";
import { CreateFundReportModal, CreateReportButton } from "../FundReport";

const HeaderContainer = styled.div`
  width: 100%;
  margin: 60px auto;
  @media ${({ theme }) => theme.bp.mobileUp} {
    margin-top: 104px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

type ProfileHeaderSectionProps = {
  allProjects: PublicProjectSummary[];
  isOwnProfile: boolean;
  isLoading: boolean;
  impactTotals: Record<ImpactType, CombinedImpactQuantities>;
  onResumeSubscription: () => Promise<any>;
  profile: User;
  userImpactAggregates: UserImpactAggregates;
  getImpactReportCsv: (args: GetImpactReportCsvRequestBody) => Promise<string>;
  accessToken: string;
};

export function ProfileHeaderSection({
  allProjects,
  isOwnProfile,
  isLoading,
  impactTotals,
  onResumeSubscription,
  profile,
  userImpactAggregates,
  getImpactReportCsv,
  accessToken,
}: ProfileHeaderSectionProps) {
  const [isCreateFundReportModalOpen, setIsCreateFundReportModalOpen] =
    useState(false);

  return (
    <Wrapper>
      <ProfileHeader
        isOwnProfile={isOwnProfile}
        resumeSubscription={onResumeSubscription}
        user={profile}
      />
      {isOwnProfile && <CompleteProfileBanner user={profile} />}
      <HeaderContainer>
        <ImpactStats
          allProjects={allProjects}
          isOwnProfile={isOwnProfile}
          impactTotals={impactTotals}
          isLoading={isLoading}
          user={profile}
          userImpactAggregates={userImpactAggregates}
        />
        {isOwnProfile && (
          <CreateReportButton
            opaque
            onClick={() => setIsCreateFundReportModalOpen(true)}
          />
        )}
      </HeaderContainer>
      {isCreateFundReportModalOpen && (
        <CreateFundReportModal
          getImpactReportCsv={getImpactReportCsv}
          accessToken={accessToken}
          user={profile}
          isOpen={isCreateFundReportModalOpen}
          onClose={() => setIsCreateFundReportModalOpen(false)}
          hasPendingImpact={values(impactTotals).some(
            (total) => total.pending > 0
          )}
        />
      )}
    </Wrapper>
  );
}
